export default {
    hCenter: {
        title: '帮助中心',
        titleMore: '更多问题',
        titleDetail: '问题详情',
        c1: '自助工具',
        c2: '换一批',
        c3: '你可能想知道',
        c4: '查看更多问题',
        c5: '更多服务',
        c6: '即时CHAT(仅通讯查询)',
        c7: '客户服务热线',
        c8: '预约服务',
        c9: '线下门店',
        c10: '我要反馈',
        c11: '我的账户',
        c12: '我的账单',
        c13: '缴付账单',
        c14: '增值卡增值',
        c15: '用量查询',
        c16: '国际漫游',
        c17: '优惠专区',
        c18: '答案没解决问题？',
        c19: '告诉我们原因，我们将提供更好的服务。',
        c20: '答案文字太多，记不清楚',
        c21: '答案没讲清楚问题原因',
        c22: '答案没讲清楚如何解决问题',
        c23: '其他',
        c24: '感谢反馈',
        c25: '更多问题',
        c26: '目录',
        c27: '答案用词太专业，难以理解',
        c28: '积分商城',
        c29: '门市地址',
        c30: '地址',
        c31: '营业时间',
        f1: '转数快',
        f2: '实际支付金额',
        f3: '此<i class="i">一次性</i>二维码有效期<i class="i">2分钟</i>，请阁下于其他应用程式完成支付后<i class="i">返回MyLink确认支付结果</i>。如需再次支付，请返回前一页再次进入此页以<i class="i">刷新二维码</i>。',
        f6: '如有使用电子券/积分但支付未成功，电子券/积分将在',
        f7: '2小时后',
        f8: '退回阁下账户并可再次使用。',
        f9: '二维码将于',
        f10: '后失效',
        f11: '「教学」',
        f12: '此手机',
        f13: '付款',
        f14: '「教学」',
        f15: '另一部手机',
        f16: '付款',
        f17: '「教学」此手机付款',
        f18: '请截图或长按保存二维码',
        f19: '打开已安装的支持FPS商户二维码支付的流动银行应用程序',
        f20: '使用二维码扫描功能，选择导入此二维码图片进行付款',
        f21: '成功付款后返回MyLink查看付款成功提示',
        f22: '「教学」另一部手机付款',
        f23: '请阁下打开另一部手机上已安装的支持FPS商户二维码支付的流动银行应用程序',
        f24: '使用二维码扫描功能直接扫描FPS二维码进行付款',
        f25: '成功付款后返回MyLink查看付款成功提示',
        f26: '警告',
        f27: '二维码已失效，请返回前一页后再次进入此页以刷新二维码。\n' +
            '如有使用电子券/积分，将在2小时后退回阁下账户并可再次使用。',
        f28: '确定',
    }
}



// WEBPACK FOOTER //
// ./src/locale/FPS/zh-cn.js